<template>
	<div>
		<div class="ts-flex">
			<div class="ts-relative ts-w-full">
				<input 
					v-model.trim="search"
					ref="search"
					type="text" class="ts-w-full ts-border ts-float-right ts-px-2 ts-py-1 ts-rounded ts-outline-none ts-pr-6"
					:placeholder="$t('promotion.searchProduct')"
				>
				<span class="ts-absolute ts-right-0 ts-mt-1 ts-mr-2" style="margin-top: 7px"><i class="fa fa-search"></i></span>
			</div>
		</div>
				<br>
		<div class="max-h ts-px-3">
			<table class="ts-w-full">
				<tr 
					class="ts-border-b ts-border-gray-400"
					v-for="(product, index) in getProduct({
							chosenProduct: model,
							search: search
					})"
					:key="index"
				>
					<td class="ts-text-xs">{{ product.product_name_en }}</td>
					<td class="ts-text-right">
						<input 
							v-model.number="product.qty"
							type="number" placeholder="qty" 
							class="ts-w-16 ts-outline-none ts-border-t ts-px-2 ts-rounded ts-mt-2 ts-text-xs"
							@keypress.enter="addItem(product)"
						>
					</td>
					<td class="ts-text-xs ts-px-4 ts-text-right">{{ getPrice(product.pro_sale_code_id) }}</td>
					<td style="width:1%" class="text-center ts-pl-4">
						<a href="#"
							v-tooltip="$t('add')"
							@click.prevent="addItem(product)"
							class="ts-mb-0"
						>
							<i class="fa fa-plus"></i>
						</a>
					</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'freeItemPeramountProductList',
	props: ['value'],
	data() {
		return {
			search: '',
			model: []
		}
	},
	created() {
    this.model = this.value
  },
	computed: {
 		...mapGetters('promotion/resource', ['getProduct', 'getPrice'])
	},
	methods: {
		addItem(item) {
			var index = _.findIndex(this.model, function(o) { return o.pro_sale_code_id == null; });
			if(index > -1) {
				this.model[index].pro_sale_code_id = item.pro_sale_code_id
				this.model[index].quantity = item.qty ? item.qty : 1
			}else {
				this.model.push({
					pro_sale_code_id: item.pro_sale_code_id,
					quantity: item.qty ? item.qty : 1
				})
			}
		}
	},
}
</script>

<style scoped>
	.max-h {
		height: 400px;
		max-height: 500px;
		overflow: scroll;
	}
</style>